// extracted by mini-css-extract-plugin
export var fullGrid = "_2d-3";
export var pdpPreviewContainer = "_2d-1";
export var previewContainer = "_2d-0";
export var togglePreviewContainer = "_2d-2";